import { CALL_API } from "../context/constValues";
import { getAuthToken } from "../context/auth-context";

/**
 * Obtener todos los pagos a proveedores
 */
export async function getAllPagoProveedores() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/getallpagoproveedores`, {
    headers: { Authorization: "Bearer " + token },
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(`${data.message || "Error al obtener pagos a proveedores"}`);
  }

  return data.result;
}

export async function getPagoProveedoresSinOrden() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/pagoproveedores/sin-orden`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "No se pudieron obtener los pagos sin orden");
  }
  return data.result || [];
}

export async function asignarPagoProveedorAOrden(idpagoproveedor, idordendepago, codigo) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/pagoproveedores/${idpagoproveedor}/asignar-orden`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ idordendepago, codigo }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "No se pudo agregar el pago a la orden");
  }
  return data.isSaved;
}

export async function quitarPagoProveedorDeOrden(idpagoproveedor, idordendepago, codigo) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/pagoproveedores/${idpagoproveedor}/quitar-orden`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ idordendepago, codigo }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "No se pudo quitar el pago de la orden");
  }
  return data.isSaved;
}
/**
 * Insertar un nuevo pago a proveedor
 */
export async function addPagoProveedor(objeto) {
  const {
    idProveedor,         // ✅ nuevo
    proveedor,
    ruc,                 // ✅ nuevo
    razonsocial,         // ✅ nuevo
    factura,
    monto,
    fechaorden,
    estado,
    idordendepago,
    metododepago = null, // ✅ NUEVO (opcional)
    comprobante = null,  // ✅ NUEVO (opcional)
  } = objeto;

  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/insertpagoproveedor`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      idProveedor,
      proveedor,
      ruc,
      razonsocial,
      factura,
      monto,
      fechaOrden: fechaorden,   // 👈 camelCase como en update
      estado,
      idordendepago,
      metododepago,             // 👈 se envía al backend
      comprobante,              // 👈 se envía al backend
    }),
  });

  let data;
  try {
    data = await response.json();
  } catch {
    throw new Error("Error al insertar pago de proveedor (respuesta inválida)");
  }
  if (!response.ok) {
    throw new Error(data.message || "Error al insertar pago de proveedor");
  }
  return data.isSaved;
}

/**
 * Actualizar un pago a proveedor
 */
export async function editPagoProveedor(objeto) {
  const {
    idpagoproveedor,
    idProveedor,
    proveedor,
    ruc = null,
    razonsocial = null,
    factura,
    monto = 0,
    fechaorden = null,
    estado,
    metododepago = null, // ✅ ya soportado
    comprobante = null,  // ✅ ya soportado
  } = objeto;

  const token = getAuthToken();
  const response = await fetch(
    `${CALL_API}/updatepagoproveedor/${idpagoproveedor}`,
    {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        idProveedor,
        proveedor,
        ruc,
        razonsocial,
        factura,
        monto,
        fechaOrden: fechaorden || null, // 👈 camelCase
        estado,
        metododepago,
        comprobante,
      }),
    }
  );

  let data;
  try {
    data = await response.json();
  } catch {
    throw new Error("Error al actualizar pago de proveedor (respuesta inválida)");
  }
  if (!response.ok) {
    throw new Error(data.message || "Error al actualizar pago de proveedor");
  }
  return data.isSaved;
}



/**
 * Eliminar un pago a proveedor
 */
export async function deletePagoProveedor(id) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/deletepagoproveedor/${id}`, {
    method: "DELETE",
    headers: { Authorization: "Bearer " + token },
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Error al eliminar pago de proveedor");
  }

  return data.isDeleted;
}

/** =========================================================
 *    PROVEEDORES DE CONTABILIDAD (base)
 * =========================================================
 */
export async function getAllProveedores() {
  const token = getAuthToken();
  const result = await fetch(`${CALL_API}/proveedores`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const data = await result.json();
  if (!result.ok) {
    throw new Error(data.message);
  }

  return data.result;
}

export async function saveProveedor(ProveedorObject) {
  const { isNew, idProveedor } = ProveedorObject;
  const token = getAuthToken();
  let urlSend = `${CALL_API}/proveedor`;
  let method = "POST";

  if (ProveedorObject.isNew) delete ProveedorObject.isNew;
  if (ProveedorObject.idProveedor) delete ProveedorObject.idForma;

  if (!isNew) {
    urlSend = `${urlSend}/${idProveedor}`;
    method = "PUT";
  }

  const result = await fetch(urlSend, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(ProveedorObject),
  });

  const data = await result.json();
  if (!result.ok) {
    throw new Error(data.message);
  }

  return data.isSaved;
}

export async function getProveedorById(idProveedores) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/proveedor/${idProveedores}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message);
  }
  return data.result;
}

export async function deleteProveedor(idProveedor) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/Proveedor/${idProveedor}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message);
  }

  return data.isDeleted;
}
/** =========================================================
 *    DESCUENTOS DE PROVEEDORES
 * =========================================================
 */

/**
 * Obtener todos los descuentos de proveedores
 */
export async function getAllDescuentosProveedores() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/getalldescuentosproveedores`, {
    headers: { Authorization: "Bearer " + token },
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Error al obtener descuentos de proveedores");
  }

  return data.result;
}

/**
 * Obtener descuentos por ID de pago proveedor
 */
export async function getDescuentosByPagoProveedor(idPagoProveedor) {
  const token = getAuthToken();
  const response = await fetch(
    `${CALL_API}/getdescuentosbypagoproveedor/${idPagoProveedor}`,
    {
      headers: { Authorization: "Bearer " + token },
    }
  );

  const data = await response.json();
  if (!response.ok) {
    throw new Error(
      data.message || "Error al obtener descuentos del pago proveedor"
    );
  }

  return data.result;
}

/**
 * Obtener descuentos por rango de fechas (fechacreacion)
 */
export async function getDescuentosProveedoresByDate(startDate, endDate) {
  const token = getAuthToken();
  const response = await fetch(
    `${CALL_API}/getdescuentosproveedoresbydate`,
    {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ startDate, endDate }),
    }
  );

  const data = await response.json();
  if (!response.ok) {
    throw new Error(
      data.message ||
        "Error al obtener descuentos de proveedores por rango de fechas"
    );
  }

  return data.result;
}

/**
 * Insertar nuevo descuento proveedor
 */
export async function addDescuentoProveedor(objeto) {
  const { idpagoproveedor, idordendepago, detalle, monto } = objeto;

  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/insertdescuentoproveedor`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      idpagoproveedor,
      idordendepago,
      detalle,
      monto,
    }),
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Error al insertar descuento de proveedor");
  }

  return data.isSaved;
}

/**
 * Editar descuento proveedor
 */
export async function editDescuentoProveedor(objeto) {
  const { iddescuentoproveedor, idpagoproveedor, idordendepago, detalle, monto } = objeto;
  const token = getAuthToken();
  const response = await fetch(
    `${CALL_API}/updatedescuentoproveedor/${iddescuentoproveedor}`,
    {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        idpagoproveedor,
        idordendepago,
        detalle,
        monto,
      }),
    }
  );

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Error al actualizar descuento proveedor");
  }

  return data.isSaved;
}

/**
 * Eliminar descuento proveedor
 */
export async function deleteDescuentoProveedor(iddescuento) {
  const token = getAuthToken();
  const response = await fetch(
    `${CALL_API}/deletedescuentoproveedor/${iddescuento}`,
    {
      method: "DELETE",
      headers: { Authorization: "Bearer " + token },
    }
  );

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Error al eliminar descuento proveedor");
  }

  return data.isDeleted;
}
